import { BetslipMessageChannels } from "../message";
export const QueryTypes = BetslipMessageChannels;
export var OddsStyle;
(function (OddsStyle) {
    OddsStyle["decimal"] = "decimal";
    OddsStyle["american"] = "american";
    OddsStyle["fractional"] = "fractional";
    OddsStyle["indonesian"] = "indonesian";
    OddsStyle["malaysian"] = "malaysian";
    OddsStyle["hongkong"] = "hongkong";
})(OddsStyle || (OddsStyle = {}));
export var CombinabilityRestrictionType;
(function (CombinabilityRestrictionType) {
    CombinabilityRestrictionType["ComboDisallowed"] = "ComboDisallowed";
    CombinabilityRestrictionType["SinglesOnly"] = "SinglesOnly";
    CombinabilityRestrictionType["SystemDisallowed"] = "SystemDisallowed";
    CombinabilityRestrictionType["TeaserDisallowed"] = "TeaserDisallowed";
    CombinabilityRestrictionType["NonCombinableGroup"] = "NonCombinableGroup";
})(CombinabilityRestrictionType || (CombinabilityRestrictionType = {}));
export var BetTypes;
(function (BetTypes) {
    BetTypes["Unknown"] = "Unknown";
    BetTypes["Single"] = "Single";
    BetTypes["Combo"] = "Combo";
    BetTypes["Forecast"] = "Forecast";
    BetTypes["Tricast"] = "Tricast";
    BetTypes["OtherCast"] = "OtherCast";
    BetTypes["Kombinator"] = "Kombinator";
    BetTypes["System2from3"] = "System2from3";
    BetTypes["Trixie"] = "Trixie";
    BetTypes["Patent"] = "Patent";
    BetTypes["System2from4"] = "System2from4";
    BetTypes["System3from4"] = "System3from4";
    BetTypes["Yankee"] = "Yankee";
    BetTypes["Lucky15"] = "Lucky15";
    BetTypes["System2from5"] = "System2from5";
    BetTypes["System3from5"] = "System3from5";
    BetTypes["System4from5"] = "System4from5";
    BetTypes["SuperYankee"] = "SuperYankee";
    BetTypes["Lucky31"] = "Lucky31";
    BetTypes["System2from6"] = "System2from6";
    BetTypes["System3from6"] = "System3from6";
    BetTypes["System4from6"] = "System4from6";
    BetTypes["System5from6"] = "System5from6";
    BetTypes["Heinz"] = "Heinz";
    BetTypes["Lucky63"] = "Lucky63";
    BetTypes["System2from7"] = "System2from7";
    BetTypes["System3from7"] = "System3from7";
    BetTypes["System4from7"] = "System4from7";
    BetTypes["System5from7"] = "System5from7";
    BetTypes["System6from7"] = "System6from7";
    BetTypes["SuperHeinz"] = "SuperHeinz";
    BetTypes["System2from8"] = "System2from8";
    BetTypes["System3from8"] = "System3from8";
    BetTypes["System4from8"] = "System4from8";
    BetTypes["System5from8"] = "System5from8";
    BetTypes["System6from8"] = "System5from8";
    BetTypes["System7from8"] = "System7from8";
    BetTypes["Goliath"] = "Goliath";
    BetTypes["System2from9"] = "System2from9";
    BetTypes["System3from9"] = "System3from9";
    BetTypes["System4from9"] = "System4from9";
    BetTypes["System5from9"] = "System5from9";
    BetTypes["System6from9"] = "System6from9";
    BetTypes["System7from9"] = "System7from9";
    BetTypes["System8from9"] = "System8from9";
    BetTypes["System2from10"] = "System2from10";
    BetTypes["System3from10"] = "System3from10";
    BetTypes["System4from10"] = "System4from10";
    BetTypes["System5from10"] = "System5from10";
    BetTypes["System6from10"] = "System6from10";
    BetTypes["System7from10"] = "System7from10";
    BetTypes["System8from10"] = "System8from10";
    BetTypes["System9from10"] = "System9from10";
    BetTypes["System2from11"] = "System2from11";
    BetTypes["System3from11"] = "System3from11";
    BetTypes["System4from11"] = "System4from11";
    BetTypes["System5from11"] = "System5from11";
    BetTypes["System6from11"] = "System6from11";
    BetTypes["System7from11"] = "System7from11";
    BetTypes["System8from11"] = "System8from11";
    BetTypes["System9from11"] = "System9from11";
    BetTypes["System10from11"] = "System10from11";
    BetTypes["System2from12"] = "System2from12";
    BetTypes["System3from12"] = "System3from12";
    BetTypes["System4from12"] = "System4from12";
    BetTypes["System5from12"] = "System5from12";
    BetTypes["System6from12"] = "System6from12";
    BetTypes["System7from12"] = "System7from12";
    BetTypes["System8from12"] = "System8from12";
    BetTypes["System9from12"] = "System9from12";
    BetTypes["System10from12"] = "System10from12";
    BetTypes["System11from12"] = "System11from12";
    BetTypes["System2from13"] = "System2from13";
    BetTypes["System3from13"] = "System3from13";
    BetTypes["System4from13"] = "System4from13";
    BetTypes["System5from13"] = "System5from13";
    BetTypes["System6from13"] = "System6from13";
    BetTypes["System7from13"] = "System7from13";
    BetTypes["System8from13"] = "System8from13";
    BetTypes["System9from13"] = "System9from13";
    BetTypes["System10from13"] = "System10from13";
    BetTypes["System11from13"] = "System11from13";
    BetTypes["System12from13"] = "System12from13";
    BetTypes["System2from14"] = "System2from14";
    BetTypes["System3from14"] = "System3from14";
    BetTypes["System4from14"] = "System4from14";
    BetTypes["System5from14"] = "System5from14";
    BetTypes["System6from14"] = "System6from14";
    BetTypes["System7from14"] = "System7from14";
    BetTypes["System8from14"] = "System8from14";
    BetTypes["System9from14"] = "System9from14";
    BetTypes["System10from14"] = "System10from14";
    BetTypes["System11from14"] = "System11from14";
    BetTypes["System12from14"] = "System12from14";
    BetTypes["System13from14"] = "System13from14";
    BetTypes["System2from15"] = "System2from15";
    BetTypes["System3from15"] = "System3from15";
    BetTypes["System4from15"] = "System4from15";
    BetTypes["System5from15"] = "System5from15";
    BetTypes["System10from15"] = "System10from15";
    BetTypes["System11from15"] = "System11from15";
    BetTypes["System12from15"] = "System12from15";
    BetTypes["System13from15"] = "System13from15";
    BetTypes["System14from15"] = "System14from15";
    BetTypes["System2from16"] = "System2from16";
    BetTypes["System3from16"] = "System3from16";
    BetTypes["System4from16"] = "System4from16";
    BetTypes["System12from16"] = "System12from16";
    BetTypes["System13from16"] = "System13from16";
    BetTypes["System14from16"] = "System14from16";
    BetTypes["System15from16"] = "System15from16";
    BetTypes["System2from17"] = "System2from17";
    BetTypes["System3from17"] = "System3from17";
    BetTypes["System4from17"] = "System4from17";
    BetTypes["System13from17"] = "System13from17";
    BetTypes["System14from17"] = "System14from17";
    BetTypes["System15from17"] = "System15from17";
    BetTypes["System16from17"] = "System16from17";
    BetTypes["System2from18"] = "System2from18";
    BetTypes["System3from18"] = "System3from18";
    BetTypes["System4from18"] = "System4from18";
    BetTypes["System14from18"] = "System14from18";
    BetTypes["System15from18"] = "System15from18";
    BetTypes["System16from18"] = "System16from18";
    BetTypes["System17from18"] = "System17from18";
    BetTypes["System2from19"] = "System2from19";
    BetTypes["System3from19"] = "System3from19";
    BetTypes["System16from19"] = "System16from19";
    BetTypes["System17from19"] = "System17from19";
    BetTypes["System18from19"] = "System18from19";
    BetTypes["System2from20"] = "System2from20";
    BetTypes["System3from20"] = "System3from20";
    BetTypes["System17from20"] = "System17from20";
    BetTypes["System18from20"] = "System18from20";
    BetTypes["System19from20"] = "System19from20";
    BetTypes["StraightForecast"] = "StraightForecast";
    BetTypes["ReversedForecast"] = "ReversedForecast";
    BetTypes["CombinationForecast"] = "CombinationForecast";
    BetTypes["StraightTricast"] = "StraightTricast";
    BetTypes["CombinationTricast"] = "CombinationTricast";
    BetTypes["ToteWin"] = "ToteWin";
    BetTypes["TotePlace"] = "TotePlace";
    BetTypes["ToteShow"] = "ToteShow";
    BetTypes["ToteWinPlace"] = "ToteWinPlace";
    BetTypes["ToteWinShow"] = "ToteWinShow";
    BetTypes["ToteWinPlaceShow"] = "ToteWinPlaceShow";
    BetTypes["TotePlaceShow"] = "TotePlaceShow";
    BetTypes["ToteExacta"] = "ToteExacta";
    BetTypes["ToteQuinella"] = "ToteQuinella";
    BetTypes["ToteTrifecta"] = "ToteTrifecta";
    BetTypes["ToteSuperfecta"] = "ToteSuperfecta";
    BetTypes["TotePentafecta"] = "TotePentafecta";
    BetTypes["ToteOmni"] = "ToteOmni";
    BetTypes["ToteDailyDouble"] = "ToteDailyDouble";
    BetTypes["TotePick3"] = "TotePick3";
    BetTypes["TotePick4"] = "TotePick4";
    BetTypes["TotePick5"] = "TotePick5";
    BetTypes["TotePick6"] = "TotePick6";
    BetTypes["TotePick7"] = "TotePick7";
    BetTypes["TotePick8"] = "TotePick8";
    BetTypes["TotePick9"] = "TotePick9";
    BetTypes["TotePick10"] = "TotePick10";
    BetTypes["ToteGrandSlam"] = "ToteGrandSlam";
    BetTypes["YourBet"] = "YourBet";
    BetTypes["Teaser"] = "Teaser";
})(BetTypes || (BetTypes = {}));
//# sourceMappingURL=betslip.js.map